export const publishableKey = 'pk_live_DDvIx8iQzdLPXmTjx98aFvXD00mkYyiCVP';